import { DashboardSpecMigrator } from '../dashboard-schema-migrator';
import { DashboardV0, DashboardV1 } from '../../dashboard-spec-versions';

/**
 * Migrates dashboard spec to version 1
 */
export const V1Migrator: DashboardSpecMigrator<DashboardV0['spec'], DashboardV1> = {
  version: '1',
  migrate: (spec) => {
    // Use spec_version instead
    if (spec.schemaVersion) {
      delete spec.schemaVersion;
    }

    // There's a type issue with the generated old spec versions where certain z.enums are not properly
    // carried over to the generated versions.  For example, the OverrideMatcherType enum
    // becomes 'unknown' in the generated versions.
    // https://github.com/chronosphereio/monorepo/blob/master/ui/viz-framework-core/src/dashboard-spec-versions/v0.ts#L124

    // Going to cast to avoid typescript issues.
    return spec as unknown as DashboardV1;
  },
};
